import { RouteObject } from "react-router-dom";
import { PrivateRoute } from "@app/components/atoms";
import {
  Features,
  GroupList,
  GroupDetail,
  MachineDetail,
  MachineTab,
  InspectionTab,
  NotFound,
  Report,
  InspectionHistory,
  DeleteAccount,
  CreateAnnouncement,
  SearchUser,
} from "@app/pages/Features";
import { AuthInterceptor } from "@app/api";
import { License } from "@app/pages/Features/License/License";
import { PrivacyPolicy } from "@app/pages/Features/PrivacyPolicy/PrivacyPolicy";
import { TermsOfUse } from "./TermsOfUse/TermsOfUse";
import { ManageTOU } from "./ManageTOU/ManageTOU";
import { MachineReportsHistoryTab } from "./GroupList/GroupDetail/MachineReportsHistoryTab/MachineReportsHistoryTab";
import { MemberTab } from "./GroupList/GroupDetail/Member/Member";
import { Trademark } from "./Trademark/Trademark";
import { AdminPermissions } from "@app/constants";
import { RestrictedByPermission } from "./PermissionGuard/RestrictedByPermission";
import { ManageTranslations } from "./ManageTranslations/ManageTranslations";
import { AcrossGroupMachines } from "./AcrossGroupMachines/AcrossGroupMachines";
import { ManagePeriodicMaintenance } from "./ManagePeriodicMaintenance/ManagePeriodicMaintenance";

const FeaturesRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <AuthInterceptor />
        <Features />
      </PrivateRoute>
    ),
    children: [
      {
        path: "/",
        element: <GroupList />,
      },
      {
        path: "/machines/search",
        element: <AcrossGroupMachines />,
      },
      {
        path: "/groups/:groupId/machines/:machineId",
        element: <MachineDetail />,
        children: [
          {
            path: "/groups/:groupId/machines/:machineId/report",
            element: <Report />,
          },
          {
            path: "/groups/:groupId/machines/:machineId/inspection-history",
            element: <InspectionHistory />,
          },
        ],
      },
      {
        path: "/groups/:id",
        element: <GroupDetail />,
        children: [
          {
            path: "/groups/:id/",
            element: <MachineReportsHistoryTab />,
          },
          {
            path: "/groups/:id/machines",
            element: <MachineTab />,
          },
          {
            path: "/groups/:id/inspection-form",
            element: <InspectionTab />,
          },
          {
            path: "/groups/:id/machines-reports-history",
            element: <MachineReportsHistoryTab />,
          },
          {
            path: "/groups/:id/members",
            element: <MemberTab />,
          },
        ],
      },
      {
        path: "/create-announcement",
        element: (
          <RestrictedByPermission required={AdminPermissions.ANNOUNCEMENTS}>
            <CreateAnnouncement />
          </RestrictedByPermission>
        ),
      },

      {
        path: "/manage-translations",
        element: (
          <RestrictedByPermission
            required={[
              AdminPermissions.TRANSLATIONS_ADMIN,
              AdminPermissions.TRANSLATIONS_USERS,
            ]}
          >
            <ManageTranslations />
          </RestrictedByPermission>
        ),
      },

      {
        path: "/manage-periodic-maintenance",
        element: (
          <RestrictedByPermission
            required={AdminPermissions.PERIODIC_MAINTENANCE}
          >
            <ManagePeriodicMaintenance />
          </RestrictedByPermission>
        ),
      },

      {
        path: "/search-user",
        element: (
          <RestrictedByPermission
            required={[
              AdminPermissions.USER_SEARCH,
              AdminPermissions.USER_MANAGE,
            ]}
          >
            <SearchUser />
          </RestrictedByPermission>
        ),
      },
      {
        path: "/license",
        element: <License />,
      },
      {
        path: "/trademark",
        element: <Trademark />,
      },

      {
        path: "/PrivacyPolicy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/TermsofUse",
        element: <TermsOfUse />,
      },
      {
        path: "/manage-tou",
        element: (
          <RestrictedByPermission required={AdminPermissions.MANAGE_TOU}>
            <ManageTOU />
          </RestrictedByPermission>
        ),
      },
      {
        path: "/delete-account",
        element: <DeleteAccount />,
      },
      {
        path: "/404",
        element: <NotFound />,
      },
      {
        path: "/*",
        element: <NotFound />,
      },
    ],
  },
];

export default FeaturesRoutes;
